import Q from 'q';
import CostAttributionList from '../../../../../common-project/component/haolv/cost-attribution-list/index'
import consumer_admin_flight_reportConfiguration
    from "../../../../lib/data-service/haolv-default/consumer_admin_flight_reportConfiguration";


export default {
    props: {},
    data() {
        return {
            // 用于收集接口(shownName)返回需要隐藏的选项对应的中文名
            hideFieldNameBox: [],
            immutableSwitch: false,
            // 组件类型--回显、编辑
            typeBox: null,
            // 回显数据
            displayType: [],
            dataBox: null,
            loading: false,
            reportConfigurations: [],
            ruleForm: {
                name: '',
            },
        }
    },
    components: {CostAttributionList},
    methods: {
        getParameterList () {
            return this.hideFieldNameBox
        },
        getData(){
            this.toSelectType();
            let data = {
                checkForm: null,
                list: []
            };
            let checkFormAll = [];
            let feeAffiliationTypeBox = null;

            this.reportConfigurations.forEach((item,index) => {
                checkFormAll.push(item.switchForm);
                if (item.parameter == "feeAffiliationId") {
                    feeAffiliationTypeBox = item.feeAffiliationType;
                }
                if (item.parameter == "attributionType") {
                    checkFormAll[index] = false;
                }
                data.list.push({
                    parameter: item.parameter,
                    parameterValue: item.parameterValue,
                    parameterForm: !item.switchForm,
                    parameterText: item.parameterText,
                });
            });
            data.list.forEach((item,index) => {
                if (item.parameter == "attributionType") {
                    item.parameterValue = feeAffiliationTypeBox == 1 ? 2 : 1;
                }
            });


            if (checkFormAll.indexOf(true) == -1) {
                // 核验通过
                data.checkForm = true;
            } else {
                // 核验不通过
                data.checkForm = false;
            }

            return data
        },
        changeSelect(){
            this.reportConfigurations.forEach((item,index) => {
                if (item.isMust == 0) {
                    item.switchForm = false;
                } else {
                    if (item.parameterValue == null || item.parameterValue == '' || item.parameterValue.length == 0) {
                        item.switchForm = true;
                    } else {
                        item.switchForm = false;
                    }
                }
            });
        },
        toSelectType(){
            this.reportConfigurations.forEach((item,index) => {
                if (item.isMust == 0) {
                    item.switchForm = false;
                } else {
                    if (item.parameterValue == null || item.parameterValue == '' || item.parameterValue.length == 0) {
                        item.switchForm = true;
                    } else {
                        item.switchForm = false;
                    }
                }
            });
        },
        validateNewUerCard(rule, value, callback) {
            this.reportConfigurations.forEach((item,index) => {
                if (item.isMust == 0) {
                    item.switchForm = false;
                } else {
                    if (item.parameterValue == null || item.parameterValue == '' || item.parameterValue.length == 0) {
                        item.switchForm = true;
                    } else {
                        item.switchForm = false;
                    }
                }
            });
            callback()
        },
        init_CostAttributionList(item){
            let params = {
                type: '002',
                showDept: item.type == 3,
            };
            if (this.$refs.CostAttributionList) {
                this.$refs.CostAttributionList.forEach((item,index) => {
                    item.init(params);
                })
            }
        },
        init (val) {
            let _this = this;
            return new Promise(function (resolve, reject) {
                _this.loading = true;
                let mock_data = val.mock_data ? val.mock_data : null;
                let display_list = val.displayList ? val.displayList : [];
                let type = val.type ? val.type : null;

                let data = {
                    // 业务类型：1机票、2火车票、3酒店、4汽车
                    businessType: val.businessType,
                };
                let SwitchCostAttributionList = true;

                if (mock_data.enable) {
                    Q.when().then(() => {
                        let reportConfigurationsData = [
                            {
                                parameterText: '出差单号',
                                parameter: 'ChuChaiDanHao',
                                type:'1',
                                opetions: null,
                            },
                            {
                                parameterText: '业务类型',
                                parameter: 'YeWuLeiXing',
                                type:'2',
                                opetions: [
                                    {
                                        code: '0',
                                        text: '因公',
                                    },
                                    {
                                        code: '1',
                                        text: '因私',
                                    }
                                ],
                            },
                            {
                                parameterText: '成本中心',
                                parameter: 'ChengBenZhongXin',
                                type:'4',
                                opetions: null,
                            }
                        ];
                        reportConfigurationsData.forEach((item,index) => {
                            item.deptName = '';
                            item.parameterValue = '';
                            item.feeAffiliationType = 0;
                            item.switchForm = false;
                        });
                        return Q.resolve(reportConfigurationsData);
                    })
                        .then((reportConfigurationsData) => {
                            _this.reportConfigurations = reportConfigurationsData;
                            return Q.resolve();
                        })
                        .then(() => {
                            _this.reportConfigurations.forEach((item,index) => {
                                if (item.type == '3' || item.type == '4') {
                                    if (SwitchCostAttributionList) {
                                        _this.$nextTick(() => {
                                            _this.init_CostAttributionList(item);
                                        });
                                        SwitchCostAttributionList = false;
                                    }
                                }
                            });
                            _this.loading = false;
                        })
                } else {
                    consumer_admin_flight_reportConfiguration(data).then(res => {
                        Q.when().then(() => {
                            _this.hideFieldNameBox = [];
                            res.datas.reportConfigurations.forEach((item,index) => {
                                item.isMust = item.isMust != 0 && item.isMust != 1 ? 1 : item.isMust;
                                item.deptName = '';
                                item.parameterValue = '';
                                item.feeAffiliationType = 0;
                                item.switchForm = false;
                                // 成本中心需回显一个默认的
                                if (item.parameter === 'feeAffiliationId') {
                                    item.deptName = '各自所在的部门';
                                    item.parameterValue = -1;
                                    item.feeAffiliationType = 1;
                                }
                                if (item.parameter === 'attributionType') {
                                    item.parameterValue = 1;
                                    item.feeAffiliationType = 1;
                                }
                                if (item.isNotShown == 1) {
                                    _this.hideFieldNameBox.push(item.shownName);
                                }
                            });
                            return Q.resolve();
                        })
                            .then(() => {
                                _this.reportConfigurations = res.datas.reportConfigurations;
                                let dataBoxOne = null;
                                if (type == 'immutable') {
                                    _this.immutableSwitch = true;
                                }
                                if (type == 'display' || type == 'immutable') {
                                    _this.reportConfigurations.forEach((RItem,TIndex) => {
                                        display_list.forEach((DItem,DIndex) => {
                                            if (RItem.parameter == DItem.parameter) {
                                                RItem.parameterValue = DItem.parameterValue;
                                                if (DItem.parameter == "attributionType") {
                                                    dataBoxOne = DItem.parameterValue
                                                }
                                            }
                                        });
                                    });

                                    _this.reportConfigurations.forEach((item,index) => {
                                        if (item.parameter == "feeAffiliationId") {
                                            item.feeAffiliationType = dataBoxOne == 1 ? 2 : 1;
                                        }
                                    });
                                }
                                _this.loading = false;
                                return Q.resolve();
                            })
                            .then(() => {
                                _this.reportConfigurations.forEach((item,index) => {
                                    if (item.type == '3' || item.type == '4') {
                                        if (SwitchCostAttributionList) {
                                            _this.$nextTick(() => {
                                                _this.init_CostAttributionList(item);
                                            });
                                            SwitchCostAttributionList = false;
                                        }
                                    }
                                });
                                _this.loading = false;
                                resolve(_this.hideFieldNameBox);
                            })
                    });
                }
            });
        }
    },
    watch: {},
    created() {

    },
    mounted() {

    },
    activated() {

    },
    deactivated() {

    },
}
